// utils/menu.js 菜单工具函数 获取第一个菜单路径
export function getFirstMenuPath(menus) {
  if (!menus || !menus.length) return 'homepage'
  const first = menus[0]
  return first.path || first.children?.[0]?.path || 'homepage'
}

export function toRoutePath(menuPath) {
  if (!menuPath || menuPath === '/' || menuPath === 'homepage') {
    return '/homepage'
  }
  return menuPath.startsWith('/') ? menuPath : `/${menuPath}`
}

export function getCachedMenuList() {
  try {
    const raw = localStorage.getItem('menuList')
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

export function getDefaultRoutePath() {
  const sessionPath = sessionStorage.getItem('path')
  if (
    sessionPath &&
    sessionPath !== 'homepage' &&
    sessionPath !== '/homepage'
  ) {
    return sessionPath.startsWith('/') ? sessionPath : `/${sessionPath}`
  }

  return toRoutePath(getFirstMenuPath(getCachedMenuList()))
}
